"use client";

import React from "react";

//Style
import * as S from "./styles";

//Types
import { FormGroupProps } from "@/types";

const FormGroup: React.FC<FormGroupProps> = ({ className, children }) => {
  return <S.FormGroup className={className}>{children}</S.FormGroup>;
};

export default FormGroup;
